import { JoinTeam } from '@/pages/teams/components/JoinTeam'

export function JoinTeamPage() {
  return <JoinTeam />
}
